import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiurbaniaonrent() {



  const cardData = {
"keyword": "Pune to Mumbai Urbania On Rent",

"headingDescription":
  "Shivai Travels offers premium Pune to Mumbai Urbania on rent for comfortable and hassle-free intercity group travel. Our Force Urbania service is ideal for families, corporate teams, wedding guests, airport transfers, and tourist groups traveling between Pune and Mumbai. Designed for long-distance comfort, our Urbania vehicles come with spacious pushback seating, strong air conditioning, smooth suspension, charging points, music system, and ample luggage space, ensuring a relaxed journey on the Pune–Mumbai Expressway. With experienced and professional drivers trained for highway driving, Shivai Travels ensures safe, punctual, and stress-free travel. Suitable for 15–17 passengers, our Pune to Mumbai Urbania rental service offers flexible options such as one-way drops, round trips, corporate bookings, and customized travel plans with doorstep pickup and 24/7 support.",

"topPlaces": [
  {
    "title": "Gateway of India",
    "description":
      "The Gateway of India is one of Mumbai’s most iconic landmarks located in Colaba, attracting tourists for heritage views, ferry rides, and seaside experiences, perfect for group visits from Pune."
  },
  {
    "title": "Marine Drive",
    "description":
      "Marine Drive is a famous coastal boulevard in South Mumbai known as the Queen’s Necklace, ideal for evening walks, sea views, and relaxing group outings."
  },
  {
    "title": "Juhu Beach",
    "description":
      "Juhu Beach is a popular beach destination in Mumbai known for street food, sunset views, and lively atmosphere, frequently visited by groups traveling from Pune."
  },
  {
    "title": "Siddhivinayak Temple",
    "description":
      "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most famous religious sites dedicated to Lord Ganesha, attracting devotees from across Maharashtra."
  },
  {
    "title": "Elephanta Caves",
    "description":
      "Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island near Mumbai, is known for ancient rock-cut sculptures and historical significance."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description":
      "Bandra-Worli Sea Link is a modern engineering marvel in Mumbai offering stunning views of the Arabian Sea and is a key highlight during city travel routes."
  },
  {
    "title": "Colaba Causeway",
    "description":
      "Colaba Causeway is a popular shopping street in South Mumbai known for cafes, street shopping, and vibrant city culture, ideal for group visits."
  },
  {
    "title": "Haji Ali Dargah",
    "description":
      "Haji Ali Dargah is a famous religious site located in the Arabian Sea, attracting visitors for its spiritual significance and unique location."
  },
  {
    "title": "Chhatrapati Shivaji Terminus",
    "description":
      "Chhatrapati Shivaji Terminus is a UNESCO World Heritage railway station in Mumbai known for its Victorian Gothic architecture and historical importance."
  },
  {
    "title": "Powai Lake",
    "description":
      "Powai Lake is a scenic artificial lake in Mumbai surrounded by greenery and urban views, making it a peaceful stop for leisure trips."
  }
],



services: [
  {
    name: "Pune to Mumbai Urbania Cab",
    description: "Pune to Mumbai Urbania cab service provides premium and spacious transportation for airport transfers, family trips, business travel, sightseeing tours, and interstate journeys. Luxury Force Urbania vehicles with experienced drivers ensure smooth and safe travel on the Pune Mumbai expressway and highway routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, and luggage space suitable for comfortable group travel. Flexible booking options allow convenient Pune to Mumbai Urbania cab reservations."
  },
  {
    name: "Urbania Pune to Mumbai Hire",
    description: "Urbania Pune to Mumbai hire service offers dependable transportation solutions for travelers planning long-distance travel between Pune and Mumbai. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Urbania hire reservations."
  },
  {
    name: "Force Urbania Mumbai Trip Pune",
    description: "Force Urbania Mumbai trip Pune service provides affordable and comfortable luxury travel options for interstate and long-distance journeys. Travelers can enjoy smooth trips with experienced drivers familiar with expressway routes, airport roads, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and sightseeing travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Force Urbania trip reservations."
  },
  {
    name: "Luxury Urbania Pune Mumbai",
    description: "Luxury Urbania Pune Mumbai service provides high-end transportation for passengers seeking comfortable and stylish group travel between Pune and Mumbai. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Cheap Pune Mumbai Urbania",
    description: "Cheap Pune Mumbai Urbania service offers economical and comfortable luxury transportation for groups traveling between Pune and Mumbai. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, airport transfers, and business journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable Urbania reservations."
  },
  {
    name: "One Way Urbania Pune Mumbai",
    description: "One way Urbania Pune Mumbai service provides comfortable transportation for families, corporate teams, and tourists traveling one-side between Pune and Mumbai. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, business travel, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way Urbania reservations."
  },
  {
    name: "Round Trip Urbania Pune Mumbai",
    description: "Round trip Urbania Pune Mumbai service offers spacious transportation for family tours, corporate outings, airport transfers, and sightseeing trips between Pune and Mumbai with return travel options. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip Urbania reservations."
  },
  {
    name: "Airport Transfer Urbania Pune Mumbai",
    description: "Airport transfer Urbania Pune Mumbai service provides reliable transportation for airport pickup and drop services between Pune and Mumbai airports. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport transfer Urbania reservations."
  },
  {
    name: "Best Urbania Pune to Mumbai",
    description: "Best Urbania Pune to Mumbai service provides dependable transportation for long-distance group travel between Pune and Mumbai for tourism, business, and family travel. Comfortable vehicles ensure smooth highway travel suitable for corporate tours, sightseeing trips, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient best Urbania reservations."
  },
  {
    name: "AC Urbania Pune Mumbai",
    description: "AC Urbania Pune Mumbai service offers spacious and comfortable transportation for interstate travel between Pune and Mumbai. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC Urbania reservations."
  },
  {
    name: "Urbania with Driver Pune Mumbai",
    description: "Urbania with driver Pune Mumbai service offers premium transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with experienced chauffeurs. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania with driver reservations."
  },
  {
    name: "Family Travel Urbania Pune Mumbai",
    description: "Family travel Urbania Pune Mumbai service offers reliable group transportation for family vacations, sightseeing tours, and long-distance travel between Pune and Mumbai. Vehicles provide spacious seating and luggage space suitable for families, senior citizens, and group travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family travel Urbania reservations."
  },
  {
    name: "Premium Urbania Pune Mumbai",
    description: "Premium Urbania Pune Mumbai service provides complete luxury transportation solutions for local and interstate travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, group outings, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Urbania reservations."
  },
  {
    name: "Outstation Urbania Mumbai Route",
    description: "Outstation Urbania Mumbai route service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for family trips, sightseeing tours, airport transfers, corporate outings, and long-distance travel between Pune and Mumbai. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Pune Mumbai Urbania Booking",
    description: "Pune Mumbai Urbania booking service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Pune Mumbai Urbania booking reservations."
  }
],

tableData: [
  ["Pune to Mumbai Urbania Cab", "Urbania Pune to Mumbai Hire"],
  ["Force Urbania Mumbai Trip Pune", "Luxury Urbania Pune Mumbai"],
  ["Cheap Pune Mumbai Urbania", "One Way Urbania Pune Mumbai"],
  ["Round Trip Urbania Pune Mumbai", "Airport Transfer Urbania Pune Mumbai"],
  ["Best Urbania Pune to Mumbai", "AC Urbania Pune Mumbai"],
  ["Urbania with Driver Pune Mumbai", "Family Travel Urbania Pune Mumbai"],
  ["Premium Urbania Pune Mumbai", "Outstation Urbania Mumbai Route"],
  ["Pune Mumbai Urbania Booking", "Pune to Mumbai Urbania Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mumbai Urbania on Rent",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Mumbai Urbania rental service with professional drivers, luxury seating, and punctual pickup for smooth and comfortable interstate travel experiences."
      },
      {
        WhyChooseheading: "Affordable Pune to Mumbai Urbania Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Mumbai Urbania on rent with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Mumbai Urbania Availability",
        WhyChoosedescription: "Our Pune to Mumbai Urbania rental service operates 24 hours a day for airport transfers, corporate travel, family tours, wedding travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Luxury & Comfortable AC Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide premium comfort during long-distance travel."
      },
      {
        WhyChooseheading: "One Way & Round Trip Urbania Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Mumbai Urbania booking, round-trip travel, airport transfers, and customized interstate travel packages."
      },
      {
        WhyChooseheading: "Perfect Vehicle for Family & Corporate Groups",
        WhyChoosedescription: "Our Urbania vehicles are ideal for family vacations, corporate teams, wedding groups, tourists, and VIP travel with spacious seating, luggage capacity, and luxury interiors."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Mumbai Highway Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Mumbai Expressway routes and ensure safe driving, smooth travel, and timely arrival for every interstate journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mumbai Urbania rental service?", answer: "Pune to Mumbai Urbania rental service provides luxury group transportation for airport transfers, family travel, corporate trips, sightseeing tours, and interstate journeys." },
    { question: "Is Pune to Mumbai Urbania on rent available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Mumbai Urbania rental service." },
    { question: "Which Urbania seating options are available for Pune to Mumbai travel?", answer: "Shivai Travels offers 10 seater, 13 seater, and 17 seater Urbania vehicles for Pune to Mumbai travel." },
    { question: "Can I book Urbania for one-way Pune to Mumbai travel?", answer: "Yes, customers can book one-way as well as round-trip Pune to Mumbai Urbania rental services." },
    { question: "Do you provide Mumbai Airport Urbania transfer service?", answer: "Yes, Shivai Travels provides Mumbai Airport pickup and drop services with luxury Urbania vehicles." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Pune to Mumbai Urbania on rent online?", answer: "Yes, customers can easily book Pune to Mumbai Urbania rental service online or through phone booking." },
    { question: "Do you provide Urbania vehicles for family and corporate group travel?", answer: "Yes, Shivai Travels provides Urbania vehicles for family tours, corporate outings, wedding groups, and VIP transportation." },
    { question: "Are Pune to Mumbai Urbania rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Mumbai Urbania rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Kulkarni",
      feedback:
        "Booked Pune to Mumbai Urbania on rent with Shivai Travels. Luxury vehicle, smooth expressway journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Patil",
      feedback:
        "Excellent Pune to Mumbai Urbania rental service. Affordable pricing, clean luxury vehicle, and wonderful group travel experience.",
      rating: 5
    }
  ];





  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania On Rent",
  "image": "https://shivaitravels.com/assets/images/pune-to-mumbai-urbania.jpg",
  "description": "Book Pune to Mumbai Urbania on rent with Shivai Travels for safe, comfortable, and luxury intercity travel. Ideal for family trips, corporate travel, airport transfers, and outstation journeys with AC comfort and professional driver service available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹28/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-mumbai-urbania"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Urbania On Rent | Luxury Intercity Cab | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Urbania on rent with Shivai Travels for luxury, safe and comfortable intercity travel. Ideal for family trips, corporate travel, airport transfers, and outstation journeys with AC comfort and driver service."
  />

  <meta
    name="keywords"
    content="pune to mumbai urbania cab, urbania pune to mumbai hire, force urbania mumbai trip pune, luxury urbania pune mumbai, cheap pune mumbai urbania, one way urbania pune mumbai, round trip urbania pune mumbai, airport transfer urbania pune mumbai, best urbania pune to mumbai, ac urbania pune mumbai, urbania with driver pune mumbai, family travel urbania pune mumbai, premium urbania pune mumbai, outstation urbania mumbai route, pune mumbai urbania booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiurbaniaonrent;